import classNames from "classnames";

export const downloadButton = classNames(
    // Mobile
    "mobile:text-lg",
    "mobile:w-64",
    "mobile:h-11",
    // Tablet
    "tablet:w-60",
    "tablet:h-12",
    "tablet:text-xl",
    // All
    "rounded-lg",
    "bg-white",
    "text-black",
    "text-center",
    "mt-4"
)

export const disclaimer = classNames(
    // Mobile
    "mobile:px-6",
    "mobile:text-[10px]",
    // Tablet
    "tablet:px-32",
    "tablet:text-xs",
    // All
    "w-full",
    "text-center",
    "pb-16",
)

export const container = classNames(
    // Mobile
    "mobile:flex-col",
    "mobile:bg-[url(/assets/free-resources/marketing/mobile-left-x.svg)]",
    "mobile:bg-no-repeat",
    "mobile:bg-[position:-98px_277px]",
    // Tablet
    "tablet:flex-row",
    // All
    "flex",
    "items-center",
    "justify-center",
    "bg-secondary",
    "text-white",
    "p-2"
)

export const image = classNames(
    // Mobile
    "mobile:p-0",
    // Tablet
    "tablet:pl-8",
    // All
    "relative",
    "-top-12",
)

export const contentText = classNames(
    // Mobile
    "mobile:pt-6",
    "mobile:w-full",
    "mobile:flex",
    "mobile:flex-col",
    "mobile:items-center",
    "mobile:justify-center",
    "mobile:p-6",
    "mobile:-top-10",
    // Tablet
    "tablet:w-1/2",
    "tablet:pl-8",
    "tablet:items-start",
    "tablet:justify-start",
    "tablet:top-0",
    // All
    "flex",
    "relative"
)

export const heading = classNames(
    // Mobile
    "mobile:text-xl",
    "mobile:text-center",
    // Tablet
    "tablet:text-3xl",
    // All
    "font-medium",
)

export const subheading = classNames(
    // Mobile
    "mobile:text-sm",
    "mobile:pl-2",
    "mobile:text-center",
    // Tablet
    "tablet:text-[20px]",
    "tablet:pl-0",
    "tablet:text-left",
    // All
    "pt-4",
    "pb-2"

)

